import { gql } from "@apollo/client";

export default gql`
  mutation deleteItem($id: ID!, $type: String!) {
    deleteItem(id: $id, type: $type)
  }
`;
